import { Icon, IconColor, IconID } from '@common/Icon/Icon';
import classNames from 'classnames';

export interface ProductNoteProps {
  html: string;
  textSize?: 'xs' | 'sm';
}
export const ProductNote = ({ html, textSize = 'xs' }: ProductNoteProps) => (
  <div className="flex mt-7" data-testid="product-notes">
    <span className="inline-flex mr-2 mt-1">
      <Icon id={IconID.INFO} size={6} color={IconColor.BLUE} title="Info" />
    </span>
    <span
      className={classNames('leading-8 user-content', textSize === 'sm' ? 'text-sm' : 'text-xs')}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  </div>
);
